
    var riot = require('riot')
    //src: starling/src/tags/node-tools.html
riot.tag2('node-tools',
  '<div class="tools" ref="tools"> <div class="toolbar" ref="toolbar"> <button if="{canEdit()}" ref="part" data-tip="Add a part" data-tip-align="top" onclick="{addPart}" ondblclick="{addPart}" onmouseenter="{setPartToolHovered}" onmouseleave="{unsetPartToolHovered}"> <svg class="node-tools_icon"> <use xlink:href="#add-part-icon"></use> </svg> </button> <button if="{canEdit()}" ref="rel" data-tip="Create a relationship line" data-tip-align="top"> <svg class="node-tools_icon"> <use xlink:href="#add-relationship-icon"></use> </svg> </button> <button if="{canEdit()}" ref="perspectivePoint" data-tip="Add a perspective" data-tip-align="top" onclick="{handlePClick}" ondblclick="{addPerspectivePoint}"> <svg class="node-tools_icon"> <use xlink:href="#add-perspective-icon"></use> </svg> </button> <button if="{canComment()}" ref="comment" data-tip="Add a comment" data-tip-align="top" onclick="{startComment}" ondblclick="{this.startComment}"> <svg class="node-tools_icon"> <use xlink:href="#comment-icon"></use> </svg> </button> <button if="{this.canEdit()}" ref="menu" class="menu" data-tip="More actions…" data-tip-align="top" onclick="{toggleMenu}"><i class="material-icons">more_vert</i></button> <div if="{this.canEdit()}" ref="partBar" class="part-tool" title="Add a part" onclick="{this.addPart}" onmouseenter="{setPartToolHovered}" onmouseleave="{unsetPartToolHovered}"></div> </div> </div>',
  'node-tools .tools,[data-is="node-tools"] .tools{ display: flex; margin-top: 10px; height: 20px; } node-tools button,[data-is="node-tools"] button{ font-size: 10px; display: block; background: rgba(255,255,255,0.25); z-index: 1200; color: rgba(0,0,0,0.5); } node-tools .hidden,[data-is="node-tools"] .hidden,node-tools .not-shown,[data-is="node-tools"] .not-shown{ display: none; }',
  'ref="main"', function(opts) {
'use strict';

var _this = this,
    _arguments = arguments;

var _perspectivesUi = require('lib/perspectives-ui.js');

var _appUi = require('lib/app-ui');

var _presentationUi = require('lib/presentation-ui');

var _presentationUi2 = _interopRequireDefault(_presentationUi);

var _perspectiveCreationUi = require('lib/perspective-creation-ui.js');

var _constants = require('lib/constants.js');

var _relationshipUi = require('lib/relationship-ui');

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _commentsUi = require('lib/comments-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = this;
this.canvas = this.opts.canvas;
this.store = this.opts.store;
this.operation = this.opts.operation;
this.canvas.nodeTools = this;
this.dontSummon = false;
this.hidden = true;

var shuttle = function shuttle(localRef, remoteRef) {
  if (!(localRef && localRef.parentNode && remoteRef)) {
    return;
  }
  localRef.parentNode.removeChild(localRef);
  remoteRef.appendChild(localRef);
  localRef.classList.remove('hidden');
};
// It's need for Safari
this.stopperPropagation = function (e) {
  e.stopImmediatePropagation();
};

this.intercept = function (e) {
  e.stopPropagation();
};

this.toggleMenu = function (e) {
  var currentTarget = e.currentTarget;
  var canvas = _this.canvas;
  var nodeMenuTag = canvas.nodeMenuTag,
      linkMenuTag = canvas.linkMenuTag;

  if (canvas.isViewOnly()) {
    return;
  }

  _this.node.instance.unsetIsNewNode();
  e.stopPropagation();
  _presentationUi2.default.pause();

  _this.canvas.autocompleteTag.hide();

  if (linkMenuTag) {
    linkMenuTag.hide();
    currentTarget.classList.remove('hover');
  }

  if (nodeMenuTag.summoned && _this.node.id == nodeMenuTag.node.id && !nodeMenuTag.childNodes) {
    nodeMenuTag.hide();
    currentTarget.classList.remove('hover');
  } else {
    _this.canvas.nodeMenuTag.summon({
      childNodes: _this.summonedFromChildNodes,
      node: _this.node,
      referenceEl: _this.refs.toolbar
    });
    _eventTracking2.default.track({
      category: 'Card Toolbar',
      action: 'Open Card Menu',
      label: 'Card Toolbar Open Menu'
    });
    currentTarget.classList.add('hover');
  }
};

this.addPerspectivePoint = function (e) {
  e.stopPropagation();
  var activePerspective = _perspectivesUi.pui.getPerspectiveFromPointNode(_this.node.id);
  if (activePerspective) {
    return;
  }
  // if a perspective point was attached to this card, revive it
  var deletedPerspective = _perspectivesUi.pui.getDeletedPerspectiveFromPointNode(_this.node.id);
  if (deletedPerspective) {
    _perspectivesUi.pui.undeletePerspective(deletedPerspective.id);
  } else {
    _perspectivesUi.pui.addPerspectivePoint({
      label: _this.node.instance.title,
      color: _perspectiveCreationUi.pcui.findNextUnusedColor(),
      pointNodeUUID: _this.node.id
    });
  }
  _this.canvas.nodePerspectivesPanelTag.update();
  _perspectivesUi.pui.refreshPerspectiveLists();
  _this.node.freshenEyeball();
  _this.node.topLevelParentTag().rediscoverLinkPositions();
};

this.handlePClick = function (e) {
  e.stopPropagation();
  var canvas = _this.canvas;
  var nodeMenuTag = canvas.nodeMenuTag;

  nodeMenuTag.hide();
  if (_this.refs.menu) {
    _this.refs.menu.classList.remove('hover');
  }
  _this.canvas.setSelectedElement(_this.node);
  _perspectivesUi.pui.startCreationFromClick();
  _eventTracking2.default.track({
    category: 'Card Toolbar',
    action: 'P Click',
    label: 'Card Toolbar P Click'
  });
};

this.handleRelClick = function (e) {
  e.stopPropagation();
  var canvas = _this.canvas;
  var nodeMenuTag = canvas.nodeMenuTag;

  nodeMenuTag.hide();
  if (_this.refs.menu) {
    _this.refs.menu.classList.remove('hover');
  }
  _this.canvas.setSelectedElement(_this.node);
  _relationshipUi.rui.startCreationFromClick();
  _eventTracking2.default.track({
    category: 'Card Toolbar',
    action: 'R Click',
    label: 'Card Toolbar R Click'
  });
};

this.suppress = function () {
  if (!_this.hidden) {
    _this._resurrect = true;
    _this.hide();
  }
  _this.isSuppressed = true;
};

this.unsuppress = function () {
  _this.isSuppressed = false;
  if (_this._resurrect) {
    _this.summon(_this._summonArgs);
  }
};

this.summon = function (_ref) {
  var node = _ref.node,
      hideRelationshipTool = _ref.hideRelationshipTool,
      hidePerspectiveTool = _ref.hidePerspectiveTool,
      summonedFromChildNodes = _ref.summonedFromChildNodes,
      positionReferenceElement = _ref.positionReferenceElement;

  _this._summonArgs = Object.assign({}, _arguments[0]);
  if (_this.isSuppressed) return;
  if (_this.canvas.isViewOnly() && !_this.canvas.canCommentOnly() || _this.dontSummon) {
    return;
  }
  if (_this.lastNode && _this.lastNode.refs.container) {
    _this.lastNode.refs.container.classList.remove('hover');
  }

  if (!node) {
    return;
  }

  if (_this.node == node) return;

  _this.hideRelationshipTool = Boolean(hideRelationshipTool);
  _this.summonedFromChildNodes = Boolean(summonedFromChildNodes);
  _this.node = _this.summonedFromChildNodes ? node.parent : node;
  _this.nodeId = node.id;
  _this.lastNode = node;
  _this.lastNodeId = node.id;
  _this.positionReferenceElement = positionReferenceElement;
  if (_this.refs.menu) {
    _this.refs.menu.classList.remove('not-shown');
  }
  _this.update();

  var _refs = _this.refs,
      rel = _refs.rel,
      perspectivePoint = _refs.perspectivePoint;

  if (rel) {
    if (_this.hideRelationshipTool) {
      rel.classList.add('hidden');
    } else {
      rel.classList.remove('hidden');
    }
  }
  if (perspectivePoint) {
    if (hidePerspectiveTool) {
      perspectivePoint.classList.add('hidden');
    } else {
      perspectivePoint.classList.remove('hidden');
    }
  }

  shuttle(_this.refs.toolbar, node.refs.menuTool);

  if (_this.refs.partBar) {
    if (_this.node.instance.getChildrenDetached() && !_this.summonedFromChildNodes && node.childNodesTag) {
      shuttle(_this.refs.partBar, node.childNodesTag.refs.partBarTool);
    } else {
      shuttle(_this.refs.partBar, node.refs.partBarTool);
    }
  }
  _this.hidden = false;
};

this.hide = function () {
  var _refs2 = _this.refs,
      toolbar = _refs2.toolbar,
      menu = _refs2.menu,
      partBar = _refs2.partBar;

  _this.nodeId = null;
  _this.node = null;

  toolbar.classList.add('hidden');
  if (menu) {
    menu.classList.add('not-shown');
    menu.classList.remove('hover');
  }
  if (partBar) {
    partBar.classList.add('hidden');
  }
  _this.hidden = true;
};

this.addPart = function (e) {
  e.preventDefault();
  e.stopPropagation();
  var canvas = _this.canvas;
  var nodeMenuTag = canvas.nodeMenuTag;

  nodeMenuTag.hide();
  if (_this.refs.menu) {
    _this.refs.menu.classList.remove('hover');
  }
  _presentationUi2.default.pause();
  _this.canvas.lastNodeCreatedWithEnterKey = null;
  _this.node.addPart();
  _eventTracking2.default.track({
    category: 'Card Toolbar',
    action: 'Add Part',
    label: 'Card Toolbar Add Part'
  });
};

this.startComment = function (e) {
  e.preventDefault();
  e.stopPropagation();
  if (_this.node) {
    _commentsUi.commentsUI.startNodeComment(_this.node.id);
  }
  _this.hide();
  _eventTracking2.default.track({
    category: 'Card Toolbar',
    action: 'Start Comment',
    label: 'Card Toolbar Start Comment'
  });
};

this.canEdit = function () {
  if (_this.canvas.store.access.permission === 'edit') return true;
  return false;
};

this.canComment = function () {
  if (_this.canvas.store.access.permission === 'edit' || _this.canvas.store.access.permission === 'comment') return true;
  return false;
};

this.setPartToolHovered = function () {
  if (_this.refs.part) {
    _this.refs.part.classList.add("hover");
  }
  if (_this.refs.partBar) {
    _this.refs.partBar.classList.add("hover");
  }
};

this.unsetPartToolHovered = function () {
  if (_this.refs.part) {
    _this.refs.part.classList.remove("hover");
  }
  if (_this.refs.partBar) {
    _this.refs.partBar.classList.remove("hover");
  }
};

this.on('update', function () {
  if (_this.node && _this.node.link && _this.node.link()) {
    _this.refs.tools.classList.add('r-tools');
  } else {
    _this.refs.tools.classList.remove('r-tools');
  }
});

this.on('mount', function () {
  if (_this.canvas.isViewOnly() && !_this.canvas.canCommentOnly()) {
    return;
  }
  if (_this.refs.menu) {
    $(_this.refs.menu).on('mousedown touchstart pointerdown', function (e) {
      e.stopPropagation();
    });
  }
  if (_this.refs.rel) {
    $(_this.refs.rel).on('click', _this.handleRelClick);

    var fromNodeRect = void 0;

    (0, _interactjs2.default)(self.refs.rel).draggable({
      onstart: function onstart(e) {
        e.preventDefault();
        e.stopPropagation();
        _presentationUi2.default.pause();
        document.body.classList.add('link-dragging');
        self.canvas.setLinkDragging(self.lastNodeId);
        _this.hide();

        var rect = _this.canvas.nodeTags[self.lastNodeId].refs.container.getBoundingClientRect();

        var _canvas$getMatrix = _this.canvas.getMatrix(),
            scale = _canvas$getMatrix.scale,
            tx = _canvas$getMatrix.tx,
            ty = _canvas$getMatrix.ty;

        var left = (rect.left - tx) / scale;
        var top = (rect.top - ty) / scale;

        var bottom = (rect.bottom - ty) / scale;
        var right = (rect.right - tx) / scale;

        var width = (rect.right - rect.left) / scale;
        var height = (rect.bottom - rect.top) / scale;
        fromNodeRect = { left: left, top: top, bottom: bottom, right: right, width: width, height: height };
        _eventTracking2.default.track({
          category: 'Card Toolbar',
          action: 'R Drag Start',
          label: 'Card Toolbar R Drag Start'
        });
      },
      onmove: function onmove(e) {
        e.preventDefault();
        self.sourceNodeTag = self.canvas.nodeTags[self.lastNodeId];
        self.sourceNodeTag.refs.container.classList.add('link-dragging-no-highlight');

        var _self$canvas$getMatri = self.canvas.getMatrix(),
            scale = _self$canvas$getMatri.scale,
            tx = _self$canvas$getMatri.tx,
            ty = _self$canvas$getMatri.ty;

        self.canvas.setDragLink({
          fromNodeId: self.lastNodeId,
          fromNodeRect: fromNodeRect,
          x: (e.clientX - tx) / scale,
          y: (e.clientY - ty) / scale
        });
        self.canvas.linksTag.update();
      },
      onend: function onend(e) {
        // memorialize our changes
        var linkId = void 0;
        try {
          var messages = [];
          var canvas = self.canvas;
          var targetNodeTag = canvas.mouseEnteredNode;

          self.sourceNodeTag.refs.container.classList.remove('link-dragging-no-highlight');

          if (!targetNodeTag && e.altKey) {
            var _ref2 = canvas.createNodeOnDblClick(e, null, false) || {},
                nodeTag = _ref2.nodeTag,
                createNodeMessages = _ref2.messages;

            if (nodeTag && createNodeMessages) {
              targetNodeTag = nodeTag;
              messages.push.apply(messages, createNodeMessages);
            }
          }

          if (targetNodeTag) {
            var targetNode = targetNodeTag.instance;
            self.canvas.linksTag.update();
            var lastNodeId = _this.canvas.linkDragging;
            var lastNode = _this.store.getNode(lastNodeId);

            self.canvas.nodeTags[targetNode.id].discoverPosition();
            self.canvas.nodeTags[lastNode.id].discoverPosition();

            if (lastNode !== targetNode) {

              var lastCurvature = localStorage.getItem(window.map_id + '-last-line-curvature') || 'arc';
              var link = {
                fromNodeId: lastNode.id,
                toNodeId: targetNode.id,
                direction: 'right',
                lineCurvature: lastCurvature,
                createdById: window.user_id
              };
              link.id = _this.store.addLink(link);
              linkId = link.id;
              messages.push(self.operation.messages.addLink({ link: link }));

              _perspectivesUi.pui.addLinkToActivePerspectives(link, messages);

              self.operation.batchOperation({
                messages: messages,
                onFailure: function onFailure(err) {
                  return console.log('batch operation failure: ' + err);
                }
              });
            }

            _this.canvas.nodeTools.summon({
              node: _this.canvas.nodeTags[targetNode.id],
              positionReferenceElement: _this.canvas.nodeTags[targetNode.id].refs.container
            });

            _eventTracking2.default.track({
              category: 'Card Toolbar',
              action: 'Create Relationship',
              label: 'Card Toolbar Create R'
            });
          }
          self.canvas.onboardingPopupTag && self.canvas.onboardingPopupTag.completeStep('relate');
        } catch (e) {
          console.warn("error creating link", e);
        }
        document.body.classList.remove('link-dragging');
        // FIX hacked this in when changing from createLink to addLink (no
        // linkNode being created by default)
        self.canvas.update();

        self.canvas.setLinkDragging(false);
        self.canvas.linksTag.update();
        if (linkId) {
          self.canvas.setSelectedElements([self.canvas.linkTags[linkId]]);
        }
      }
    });
  }

  if (self.refs.perspectivePoint) {
    (0, _interactjs2.default)(self.refs.perspectivePoint).draggable({
      onstart: function onstart(e) {
        e.preventDefault();
        e.stopPropagation();
        _presentationUi2.default.pause();
        document.body.classList.add('link-dragging');
        self.canvas.setLinkDragging(self.lastNodeId);
        _this.hide();

        if (document.activeElement) document.activeElement.blur();

        self.canvas.refs.perspectiveDragElement.classList.add('active');
        self.selectedPerspective = _perspectivesUi.pui.getPerspectiveFromPointNode(self.lastNodeId);
        var deletedPerspective = _perspectivesUi.pui.getDeletedPerspectiveFromPointNode(self.lastNodeId);

        var nodeTag = self.canvas.nodeTags[self.lastNodeId];

        nodeTag.enablePerspectiveEyeballTags = true;
        nodeTag.update({ forceUpdate: true });

        nodeTag.refs.container.classList.add('no-fade');

        if (deletedPerspective) {
          _this.perspectiveColor = deletedPerspective.color;
          nodeTag.showPreviewEyeball(_this.perspectiveColor);
        } else if (self.selectedPerspective) {
          _this.perspectiveColor = self.selectedPerspective.color;
        } else {
          _this.perspectiveColor = _perspectiveCreationUi.pcui.findNextUnusedColor();
          nodeTag.showPreviewEyeball(_this.perspectiveColor);
        }
        nodeTag.topLevelParentTag().rediscoverLinkPositions();
        var eyeballRect = nodeTag.getEyeballBoundingBox();

        _this.dragStartPos = {
          x: (eyeballRect.left + eyeballRect.right) / 2,
          y: (eyeballRect.top + eyeballRect.bottom) / 2 + 5
        };

        self.canvas.refs.perspectiveDragElement.style.backgroundColor = _this.perspectiveColor;
        self.canvas.refs.perspectiveDragPath.style.stroke = _this.perspectiveColor;

        _this.dragFromNode = nodeTag;
        _eventTracking2.default.track({
          category: 'Card Toolbar',
          action: 'P Drag Start',
          label: 'Card Toolbar P Drag Start'
        });
      },
      onmove: function onmove(e) {
        e.preventDefault();
        e.stopPropagation();
        self.sourceNodeTag = self.canvas.nodeTags[self.lastNodeId];
        self.sourceNodeTag.refs.container.classList.add('link-dragging-no-highlight');

        var _self$canvas$getMatri2 = self.canvas.getMatrix(),
            scale = _self$canvas$getMatri2.scale,
            tx = _self$canvas$getMatri2.tx,
            ty = _self$canvas$getMatri2.ty;

        var el = self.canvas.refs.perspectiveDragElement;
        el.style.left = (e.clientX - tx) / scale + 'px';
        el.style.top = (e.clientY - ty - 10) / scale + 'px';

        var dx = (_this.dragStartPos.x - e.clientX) / scale;
        var dy = (_this.dragStartPos.y - e.clientY) / scale;

        var path = self.canvas.refs.perspectiveDragPath;
        path.setAttribute("d", 'M 5 5 l ' + dx + ' ' + dy);
      },
      onend: function onend(e) {
        self.sourceNodeTag.refs.container.classList.remove('link-dragging-no-highlight');

        try {
          var nodeTag = _this.dragFromNode;
          nodeTag.refs.container.classList.remove('no-fade');

          var targetNodeTag = self.canvas.mouseEnteredNode;
          if (targetNodeTag && targetNodeTag !== nodeTag) {
            var targetNode = targetNodeTag.instance;
            var lastNodeId = _this.canvas.linkDragging;
            var lastNode = _this.store.getNode(lastNodeId);

            self.canvas.nodeTags[targetNode.id].discoverPosition();
            self.canvas.nodeTags[lastNode.id].discoverPosition();

            var operationMessages = [];

            if (lastNode !== targetNode) {
              var activePerspective = _perspectivesUi.pui.getPerspectiveFromPointNode(lastNodeId);

              if (!activePerspective) {
                _perspectivesUi.pui.togglePerspectivePoint({
                  nodeTag: _this.canvas.nodeTags[lastNodeId],
                  color: _this.perspectiveColor,
                  operationMessages: operationMessages
                });
              }
              activePerspective = _perspectivesUi.pui.getPerspectiveFromPointNode(lastNodeId);

              _perspectivesUi.pui.addNodeToPerspective(activePerspective, targetNode, operationMessages);
              nodeTag.setPointPerspective(activePerspective);
              nodeTag.unsetPreviewEyeball();
              nodeTag.topLevelParentTag().rediscoverLinkPositions();

              targetNodeTag.enablePerspectiveDotTags = true;
              targetNodeTag.update({ forceUpdate: true });

              var targetDots = _this.canvas.nodePerspectiveDotsTag[targetNodeTag.id];
              var newDot = targetDots.getDot(activePerspective.id);
              if (newDot) {
                newDot.openAnnotation();
              }
              if (_perspectivesUi.pui.hasPersistentPerspective() && !_perspectivesUi.pui.perspectiveIsPersistent(activePerspective.id)) {
                // if we created a new perspective, turn off current active perspective
                _perspectivesUi.pui.unsetAllPerspectives();
              }
              self.operation.batchOperation({
                messages: operationMessages,
                onFailure: function onFailure(err) {
                  return console.log('perspective drag-drop failure: ' + err);
                }
              });

              _eventTracking2.default.track({
                category: 'Card Toolbar',
                action: 'Create Perspective',
                label: 'Card Toolbar Create P'
              });
            }

            _this.canvas.nodeTools.summon({
              node: _this.canvas.nodeTags[targetNode.id],
              positionReferenceElement: _this.canvas.nodeTags[targetNode.id].refs.container
            });
          } else {
            // no perspective made
            // if aborted, remove the eyeball
            if (!self.selectedPerspective) {
              nodeTag.hidePreviewEyeball();
              nodeTag.topLevelParentTag().rediscoverLinkPositions();
            }
          }
        } catch (e) {
          console.warn("error creating perspective", e);
        }
        self.dragFromNode = null;
        self.selectedPerspective = null;
        _this.perspectiveColor = null;
        self.canvas.refs.perspectiveDragElement.classList.remove('active');
        document.body.classList.remove('link-dragging');
        self.canvas.setLinkDragging(false);
      }
    });
  }
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-tools')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-tools.html
// module id = 606
// module chunks = 0